import { Button, User } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './edit-address.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  user: User | null
  opportunity: boolean
  onRedirect?: (path: string) => any
}

export default ({ user, opportunity, onRedirect }: Props) => {
  const [t] = useTranslation('modalContractAccepted')

  const handleRedirect = (path: string) => {
    if (onRedirect && typeof onRedirect === 'function') {
      onRedirect(path)
    }
  }

  return (
    <section className="edit-address">
      <hr />
      <div className="edit-address-content">
        <h5 dangerouslySetInnerHTML={{ __html: t('editAddress.title') }} style={{ fontWeight: 400 }}></h5>
        <div className="edit-address-card">
          <h6>
            <i className="mr-2 fa-solid fa-map-location-dot" style={{ color: 'var(--text_color)' }}></i>
            {user?.profileadditionalinfo?.address}
          </h6>
          <p>{user?.profileadditionalinfo?.complement}</p>
          <p>{`${user?.profileadditionalinfo?.neighborhood} - ${user?.profileadditionalinfo?.city} - ${user?.profileadditionalinfo?.uf}`}</p>
          <p>{user?.profileadditionalinfo?.zipcode?.replace(/(\d{5})(\d{1}|d{2}|d{3})/g, '$1-$2')}</p>
          <Button
            className="mt-3"
            id="edit-address-redirect"
            onClick={() => handleRedirect('/profile/address')}
            size="sm"
            color="transparent"
            textColor="var(--primary_color)"
            borderColor="var(--primary_color)"
          >
            <span>
              <i className="mr-2 fa-solid fa-edit" style={{ color: 'var(--primary_color)' }}></i>
              {t('editAddress.button')}
            </span>
          </Button>
        </div>
        <p>{opportunity ? t('editAddress.messageOpportunity') : t('editAddress.message')}</p>
      </div>
    </section>
  )
}
